import { render } from "./IconDelete.vue?vue&type=template&id=9f7fbcfe"
import script from "./IconDelete.vue?vue&type=script&lang=js"
export * from "./IconDelete.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/miniapp-meter-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/assets/js/components/Icons/Icons/24/IconDelete.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9f7fbcfe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9f7fbcfe', __exports__)) {
    api.reload('9f7fbcfe', __exports__)
  }
  
  module.hot.accept("./IconDelete.vue?vue&type=template&id=9f7fbcfe", () => {
    api.rerender('9f7fbcfe', render)
  })

}


export default __exports__